import { getImageIdFromImage } from 'lib/image/imageUtils'

export default function getResizableImage(image?: App.Image): App.Image | undefined {
  const imageId = getImageIdFromImage(image)

  if (!image?.url || !imageId || imageId === image.id) {
    return image
  }

  return {
    ...image,
    id: imageId,
  }
}
